import { useSelector } from 'react-redux';

export default function CustomizedThemeColor() {
  
    const customizedTheme = useSelector(state => state.ThemeSwitcher.sidebarTheme);
  return `
      ${customizedTheme.backgroundColor} !important;
  `;
}
